import type { ReactNode } from 'react';
import { Header } from '@/components/home/Header';
import { Footer } from '@/components/home/Footer';

interface LegalLayoutProps {
  title: string;
  children: ReactNode;
}

export function LegalLayout({ title, children }: LegalLayoutProps) {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-bg-primary text-fg-primary">
        <div className="mx-auto max-w-3xl px-4 pb-24 pt-32 md:px-6">
          <p className="mb-3 text-sm uppercase tracking-widest text-accent-dispatch">Rechtliches</p>
          <h1 className="font-display text-4xl font-bold leading-tight md:text-5xl">{title}</h1>
          <div className="prose prose-invert mt-8 max-w-none text-fg-primary">{children}</div>
        </div>
      </main>
      <Footer />
    </>
  );
}
